import { useState } from "react";
import { cn } from "../../../../../utils/classnames";
import { useDisclosure } from "../../../../../hooks";
import { useTranslation } from "react-i18next";

const ChauffeurPickUpSpot = ({ typo14, is, mapInfo, terminal, isFromAirport }) => {
  const { t, i18n } = useTranslation();
  const { isOpen, onToggle } = useDisclosure();

  return (
    <div className="tw:rounded-[5px] tw:border tw:border-[#e8e8e8] tw:bg-white tw:py-[30px] tw:lg:px-7">
      <div className="tw:px-5 tw:pb-6 tw:lg:px-0">
        <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-bold tw:leading-[22px] tw:text-[#282828]">
          {t("bookingDetail.chauffeurPickUpSpot.title")}
        </div>
      </div>

      <div className="tw:h-px tw:w-full tw:bg-[#e8e8e8]" />

      <div className="tw:flex tw:flex-col tw:gap-4 tw:px-5 tw:pt-6 tw:lg:px-0">
        <p className={cn("tw:font-hanken-grotesk tw:!mb-0 tw:text-[#282828]", typo14)}
          dangerouslySetInnerHTML={{
            __html: t("bookingDetail.chauffeurPickUpSpot.description"),
          }}
        >
        </p>

        <button
          type="button"
          onClick={onToggle}
        >
          <div className="tw:flex tw:h-10 tw:w-full tw:items-center tw:justify-center tw:gap-2 tw:rounded-[5px] tw:border tw:border-[#f1f1f2] tw:bg-[#f1f1f2] tw:px-6">
            <span className="tw:font-hanken-grotesk tw:text-[14px] tw:font-normal tw:leading-5 tw:text-[#282828]">
              {isOpen ? t("bookingDetail.chauffeurPickUpSpot.hideMap") : t("bookingDetail.chauffeurPickUpSpot.showMap")}
            </span>
            <span className="tw:relative tw:size-4 tw:rounded-full tw:border tw:border-[#7c7b7b]">
              <span className="tw:absolute tw:left-1/2 tw:top-1/2 tw:h-px tw:w-2 tw:-translate-x-1/2 tw:-translate-y-1/2 tw:bg-[#7c7b7b]" />
              <span
                className={cn(
                  "tw:absolute tw:left-1/2 tw:top-1/2 tw:h-2 tw:w-px tw:-translate-x-1/2 tw:-translate-y-1/2 tw:bg-[#7c7b7b]",
                  {
                    "tw:hidden": isOpen,
                  }
                )}
              />
            </span>
          </div>
        </button>

        {isOpen && (
          <img
            src={isFromAirport ? mapInfo.terminal[terminal] : mapInfo.terminal}
            className="tw:w-full tw:h-auto tw:object-contain"
            alt={i18n.language === "jp" ? mapInfo.name.jp : mapInfo.name.en}
          />
        )}
      </div>
    </div>
  );
};

export default ChauffeurPickUpSpot;